import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.nav `
  display: flex;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }
`;
const List = styled.ul `
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
`;
const Item = styled.li `
  display: block;
  height: 100%;
  padding: 0px calc(${fluid(12, 62, Device.TabletLarge)} / 2);

  &:first-of-type {
    padding-left: 0;
  }
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  gap: ${fluid(6, 8)};
  color: currentColor;
  ${fonts.apparat.medium}
  font-size: ${fluid(12, 18)};
  height: 100%;
  line-height: 1em;
  text-decoration: none;

  ${Item}:focus-within &,
  ${Item}:hover &,
  &[aria-current="true"] {
    text-decoration: underline;
  }

  &:not([href]) {
    cursor: default;
  }

  svg {
    display: block;
    width: ${fluid(8, 10)};
  }
`;
const DropdownWrapper = styled(m.div) `
  ${scrollbars}

  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  background: ${brand.primary.blueGrey};
  color: ${brand.base.blue};
  max-height: calc(90vh - var(--headerHeight));
  overflow-y: auto;
  width: 100%;
`;
const DesktopNavigationStyles = {
    Container,
    DropdownWrapper,
    Item,
    Link,
    List,
};
export default DesktopNavigationStyles;
